<template>
  <mdb-container v-if="details" class="gp-has-header" fluid>
    <mdb-card class="mb-4">
      <mdb-card-body class="text-left">
        <mdb-btn icon="sync" @click="loadDetails" size="sm">Refresh</mdb-btn>
        <mdb-btn icon="money-bill-wave" size="sm"
                 v-if="settings.features.systemBilling">
          <router-link class="text-white" to="/admin/billing">Billing</router-link>
        </mdb-btn>
        <mdb-btn icon="users" v-if="userDetails.isAdmin" size="sm">
          <router-link class="text-white" to="/users">User Admin</router-link>
        </mdb-btn>
        <mdb-btn icon="list" size="sm"
               v-if="settings.features.issueTracker">
          <router-link class="text-white" to="/issues">Issues</router-link>
        </mdb-btn>
        <mdb-btn icon="key" v-if="userDetails.isAdmin" size="sm">
          <router-link class="text-white" to="/users/1/proxy">Super User</router-link>
        </mdb-btn>
      </mdb-card-body>
    </mdb-card>
    <mdb-row v-if="details.formResponses.length > 0 ">
      <mdb-col class="mb-4 text-left" col="12" >
        <mdb-card cascade class="cascading-admin-card">
          <mdb-card-body cascade>
            <div class="admin-up">
              <i class="fas fa-bell-exclamation text-danger"></i>
              <div class="data">
                <h5>Submitted Forms</h5>
                <mdb-tbl responsive striped>
                  <mdb-tbl-body>
                    <tr v-for="i in details.formResponses"
                        :key="i.id" class="text-left"
                        @click="showResponse(i)" style="cursor:pointer;"
                    >
                      <td>
                        {{i.formName}} - Submitted by {{i.user}} on {{i.submitted}}
                      </td>
                    </tr>
                  </mdb-tbl-body>
                </mdb-tbl>
              </div>
            </div>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>

      <mdb-row v-if="details.submittedIssues.length > 0 ">
      <mdb-col class="mb-4" md="6" xl="6">
        <mdb-card cascade class="cascading-admin-card">
          <mdb-card-body cascade>
            <div class="admin-up">
              <i class="fas fa-bell-exclamation text-danger"></i>
              <div class="data">
                <h5>Submitted Issues</h5>
                <div v-if="details.submittedIssues.length==0">
                  <i>No unprocessed issue submissions.</i>
                </div>
                <mdb-tbl v-if="details.submittedIssues.length>0" responsive striped>
                  <mdb-tbl-body>
                    <tr v-for="i in details.submittedIssues" :key="i.id" class="text-left">
                      <td>
                        <mdb-chip :alt="i.submittedBy" :src="i.submitAvatar" size="lg" waves>
                          {{ i.submittedBy }}
                        </mdb-chip>
                      </td>
                      <td>
                        <router-link :to="'/issues/show/' + i.id">
                          {{ i.title }} ({{ i.createDate }})
                        </router-link>
                      </td>
                    </tr>
                  </mdb-tbl-body>
                </mdb-tbl>
              </div>
            </div>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>

      <mdb-col class="mb-4" md="6" xl="6">
        <mdb-card cascade class="cascading-admin-card">
          <mdb-card-body cascade>
            <div class="admin-up">
              <i class="fas fa-envelope text-warning"></i>
              <div class="data">
                <h5>Unprocessed Help Requests</h5>
                <div v-if="details.helpRequests.length==0">
                  <i>No unprocessed requests.</i>
                </div>
                <mdb-tbl v-if="details.helpRequests.length>0" responsive striped>
                  <mdb-tbl-head class="primary-color text-white">
                    <tr>
                      <th>Date</th>
                      <th>Sender</th>
                      <th>Subject</th>
                    </tr>
                  </mdb-tbl-head>
                  <mdb-tbl-body>
                    <tr v-for="r in details.helpRequests" :key="r.id" class="text-left">
                      <td>
                        {{ r.date }}
                      </td>
                      <td>
                        {{ r.sender }}
                      </td>
                      <td>
                        <router-link :to="'/admin/help/show/'+r.id">
                          {{ r.subject }}
                        </router-link>
                      </td>
                    </tr>
                  </mdb-tbl-body>
                </mdb-tbl>
              </div>
            </div>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>

    </mdb-row>
    <mdb-row v-if="details.userDeletes.length >0">
      <mdb-col lg="12" md="12">
        <!--Panel-->
        <mdb-card class="mb-4">
          <div class="card-header white-text primary-color">
            Users Ready to Delete
          </div>
          <mdb-card-body class="text-left">
            <div v-for="(u,i) in details.userDeletes" :key="i" class="mb-4">
              <h4>{{ u.name }}</h4>
              <router-link :to="'/users/'+u.id">
                <mdb-chip :alt="u.name" :src="u.avatar" size="lg" waves>
                  {{ u.name }}
                </mdb-chip>
              </router-link>
              <div v-if="u.ownedGroups.length >0">
                <div class="text-danger">User is a group owner!</div>
                <ul>
                  <li v-for="(group,i) in u.ownedGroups" :key="i">
                    <router-link :to="'/admin/group/' + group.id">{{ group.name }}</router-link>
                  </li>
                </ul>
              </div>
              <mdb-btn v-if="u.ownedGroups.length == 0" color="danger" rounded size="sm" @click="deleteUser(u)">
                Delete
              </mdb-btn>
              <mdb-btn v-if="u.ownedGroups.length > 0 && !u.paidThrough" color="danger" rounded size="sm"
                       @click="deleteUser(u)">Delete User & Owned Groups
              </mdb-btn>
              <hr/>
            </div>
          </mdb-card-body>

        </mdb-card>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-col lg="6" md="12" v-if="details.pendingGroupJoins.length > 0">
        <!--Panel-->
        <mdb-card class="mb-4">
          <div class="card-header white-text primary-color">
            Pending Group Join Requests
          </div>
          <mdb-card-body class="text-left">
            <div v-for="(g,i) in details.pendingGroupJoins" :key="i" class="mb-4">
              <h4>
                <router-link :to="'/group/'+g.id + '/members?view=pending'">{{ g.name }}</router-link>
              </h4>
              <hr/>
            </div>
          </mdb-card-body>

        </mdb-card>
      </mdb-col>


      <mdb-col lg="6" md="12" v-if="details.needApproval.length > 0">
        <!--Panel-->
        <mdb-card class="mb-4">
          <div class="card-header white-text primary-color">
            Groups Requesting Approval
          </div>
          <mdb-card-body class="text-left">
            <div v-for="(g,i) in details.needApproval" :key="i" class="mb-4">
              <h4>
                <router-link :to="'/admin/group/'+g.id + '?from=dashboard'">{{ g.name }}</router-link>
              </h4>
              <p><b>Owner:</b>{{ g.ownerName }}</p>
              <hr/>
            </div>
          </mdb-card-body>

        </mdb-card>
      </mdb-col>
      <mdb-col lg="6" md="12" v-if="details.groupDeletes.length > 0" >
        <!--Panel-->
        <mdb-card class="mb-4">
          <div class="card-header">
            Groups Ready to Delete
          </div>
          <mdb-card-body class="text-left">
            <div v-for="(g,i) in details.groupDeletes" :key="i" class="mb-4">
              <h4>{{ g.name }}</h4>
              <p><b>Created:</b> {{ g.created }}</p>
              <p><b>Members:</b> {{ g.members }}</p>
              <router-link :to="'/users/'+g.ownerId">
                <mdb-chip :alt="g.ownerName" :src="g.ownerAvatar" size="lg" waves>
                  {{ g.ownerName }}
                </mdb-chip>
              </router-link>
              <mdb-btn rounded size="sm" @click="removeDelete(g)">Remove from List</mdb-btn>
              <mdb-btn color="danger" rounded size="sm" @click="deleteGroup(g)">Delete</mdb-btn>
              <hr/>
            </div>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>

      <mdb-col lg="6" md="12" v-if="details.inactiveGroups.length > 0">
        <mdb-card class="mb-4">
          <div class="card-header">
            Inactive Groups
          </div>
          <mdb-card-body class="text-left">
            <div :key="i" class="mb-4" v-for="(g,i) in details.inactiveGroups">
              <h4><router-link :to="'/admin/group/' + g.id" >{{ g.name }}</router-link></h4>
              <p><b>Last Visited:</b> {{ g.lastVisited }}</p>
              <p><b>Members:</b> {{ g.members }}</p>
              <p><b>Events:</b> {{ g.events }}</p>
              <p><b>Owner:</b>
                <router-link :to="'/users/'+g.ownerId">
                  {{ g.ownerName }}
                </router-link>
              </p>
              <mdb-btn @click="notifyDeletion(g)" rounded size="sm">Notify for Deletion</mdb-btn>
              <hr/>
            </div>
          </mdb-card-body>

        </mdb-card>
      </mdb-col>

    </mdb-row>
    <mdb-row>
      <mdb-col lg="6" md="12">
        <mdb-card class="mb-4">
          <div class="card-header">
            Newest Groups
          </div>
          <mdb-card-body v-for="(g,i) in details.newestGroups" :key="i" class="mb-4">
            <group-card v-if="userDetails.isAdmin" :tenantName="g.tenant" :group="g"/>
            <group-card v-if="!userDetails.isAdmin" :group="g"/>
            <div class="text-left">
              {{ g.summary ? g.summary : "No Summary Yet" }}
            </div>
            <router-link :to="'/users/'+g.ownerId">
              <mdb-chip :alt="g.ownerName" :src="g.ownerAvatar" size="lg" waves>
                {{ g.ownerName }}
              </mdb-chip>
            </router-link>
          </mdb-card-body>

        </mdb-card>
      </mdb-col>

      <mdb-col lg="6" md="12">
        <mdb-card class="mb-4">
          <div class="card-header">
            Newest Users
          </div>
          <mdb-card-body>
            <div v-for="(u,i) in details.newestUsers" :key="i" class="mb-4 text-left">
              <div>
                <b>
                  <a :href="u.avatarFull" target="_blank"><avatar :avatar="u.avatar" :name="u.name" /></a>
                  {{ u.name }}</b> (#{{ u.id }}) <span class="text-info small"><i>{{u.createDate}}</i></span>
              </div>
              <div>
                Username <b>
                <router-link  v-if="userDetails.isAdmin" :to="'/users/'+u.id">{{ u.username }}</router-link>
                <span v-if="!userDetails.isAdmin">{{ u.username }} </span>
              </b></div>
              <div>
                {{ u.email }}
              </div>
              <div v-if="u.groups && u.groups.length>0">
                <mdb-badge class="mr-1 ml-1"
                           :color="getStatusColor(g.status)"
                           v-for="(g,i) in u.groups" :key="i">{{ (g.name + (userDetails.isAdmin ? ' (' + g.tenant + ')' : '' )) }}</mdb-badge>
              </div>
              <div v-if="!u.groups || u.groups.length==0">
                <mdb-badge v-if="u.memberships==0 && !u.noGroupsNotified" color="danger">No Groups</mdb-badge>
                <mdb-badge v-if="u.memberships==0 && u.noGroupsNotified" color="warning">No Groups (Notified)
                </mdb-badge>
              </div>
              <div style="clear:both;"/>
            </div>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>
    <yes-no-modal v-if="deleteGroupModal" @no="deleteGroupModal=false" @yes="doDeleteGroup()"/>
    <yes-no-modal v-if="deleteUserModal" @no="deleteUserModal=false" @yes="doDeleteUser()"/>
    <mdb-modal v-if="showFormResponseModal" @close="closeResponseModal" size="lg" removeBackdrop scrollable>
      <mdb-modal-header :close="true" center class="secondary-color"><h5>Form Response</h5></mdb-modal-header>
      <mdb-modal-body class="text-left">
        <form-response :response-id="responseId"/>
      </mdb-modal-body>
    </mdb-modal>


  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from "mdbvue";
import GroupCard from "../group/Card";
import Avatar from "../common/Avatar";
import UserChip from "../common/UserChip";
import YesNoModal from "../common/YesNoModal";
import FormResponse from "../user/FormResponse";

export default {
  name: "Admin-Dashboard",
  components: {
    FormResponse,
    YesNoModal,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbChip,
    mdbBtn,
    mdbBadge,
    mdbModal,
    mdbIcon,
    mdbModalHeader,
    mdbModalBody,
    mdbTbl, mdbTblHead, mdbTblBody,
    GroupCard,
    Avatar,
    UserChip
  },
  data() {
    return {
      details: null,
      deleteGroupModal: false,
      deleteUserModal: false,
      deleteChargeModal: false,
      deleteCandidate: null,
      executingCount: 0,
      responseId: null,
      showFormResponseModal: false
    };
  },
  mounted() {
    document.title = "Admin Dashboard"
    this.loadDetails()
  },
  computed: {
    settings() {
      return this.$store.state.settings
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  methods: {
    showResponse(r) {
      this.responseId = `${r.id}`
      this.showFormResponseModal = true
    },
    getStatusColor(status) {
      if (status == "Active") return "success"
      if (status == "Pending") return "warning"
      else return "danger"
    },
    emptyDetails() {
      this.details = {
        apiUsage: [], topUsers: [], newestGroups: [], newestUsers: [], readyToCharge: [], needToNotify: [],
        submittedIssues: [], helpRequests: [], userDeletes: [], groupDeletes: [], inactiveGroups: [], needApproval: [],
        paymentErrors: [], formResponses: [], pendingGroupJoins: []
      }
    },
    closeResponseModal() {
      this.details["formResponses"] = []
      this.getSection("formResponses")
      this.showFormResponseModal = false
    },
    loadDetails() {
      this.emptyDetails()
      this.getSection("newestGroups")
      this.getSection("needApproval")
      this.getSection("newestUsers")
      this.getSection("submittedIssues")
      this.getSection("userDeletes")
      this.getSection("groupDeletes")
      this.getSection("formResponses")
      this.getSection("inactiveGroups")
      this.getSection("pendingGroupJoins")
    },
    getSection(query) {
      api.get("/admin/dashboard?q=" + query).then(
        (results) => {
          this.details[query] = results.data
        },
        (error) => {
          if (error.response.status == 403) {
            this.$router.push("/403")
            return;
          }
          this.$notify.error({message: error.response.data, timeOut: 20000})

        })
    },
    removeDelete(group) {
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/noDelete", group).then(
        (results) => {
          let loc = this.details.groupDeletes.indexOf(group)
          this.details.groupDeletes.splice(loc, 1)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    deleteGroup(group) {
      this.deleteCandidate = group
      this.deleteGroupModal = true
    },
    doDeleteGroup() {
      this.deleteGroupModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/deleteGroup", this.deleteCandidate).then(
        (results) => {
          let loc = this.details.groupDeletes.indexOf(this.deleteCandidate)
          this.details.groupDeletes.splice(loc, 1)
          this.deleteCandidate = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    deleteUser(user) {
      this.deleteCandidate = user
      this.deleteUserModal = true
    },
    async doDeleteUser() {
      this.deleteUserModal = false
      this.$store.dispatch("setExecuting", true)

      if (this.deleteCandidate.ownedGroups.length > 0) {
        await api.post("/admin/deleteOwnedGroups", this.deleteCandidate).then(
          () => {
            this.$notify.success({message: "Owned groups deleted.", timeOut: 3000})
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }

      api.post("/admin/deleteUser", this.deleteCandidate).then(
        () => {
          this.$notify.success({message: "User deleted.", timeOut: 3000})
          let loc = this.details.userDeletes.indexOf(this.deleteCandidate)
          this.details.userDeletes.splice(loc, 1)
          this.deleteCandidate = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    notifyDeletion(group) {
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/notifyDeletion", group).then(
        (results) => {
          let loc = this.details.inactiveGroups.indexOf(group)
          this.details.inactiveGroups.splice(loc, 1)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }

}
;
</script>

<!-- Add 'scoped" attribute to limit CSS to this component only -->
<style scoped></style>
